import module from 'kendu/legacy/module'

module.filter('toPercent', () => {
  return (val, decimals) => val >= 0 ? (Number(val) * 100).toFixed(decimals || 0) + '%' : val
})



// WEBPACK FOOTER //
// ./src/deprecated/filters/toPercent.js